import React from "react";
import { Link } from "react-router-dom";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";

import ForgotPasswordForm from "../../Components/Forms/ForgotPassword";

const useStyles = makeStyles({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        position: "relative",
        zIndex: 1,
    },
});

const ForgotPassword = () => {
    const classes = useStyles();
    return (
        <Container className={classes.containerRoot} maxWidth="sm">
            <Card className={classes.cardRoot}>
                <Box marginTop="64px" marginBottom="8px">
                    <Typography
                        variant="h2"
                        align="center"
                    >
						Forgot your password?
                    </Typography>
                </Box>
                <Box marginBottom="32px">
                    <Typography
                        align="center"
                    >
						Enter your e-mail address and we&apos;ll send a reset link for your password.
                    </Typography>
                </Box>
                <ForgotPasswordForm />
            </Card>
        </Container>
    );
};

export default ForgotPassword;
